import firebase from '../util/firebase';
import GeoFire from 'geofire';

const URL = 'cameras-localizacao';
let geofire, geoQuery;
let cameras = [];

export const camerasIsLoading = (isLoading) => ({ type: 'CAMERA_IS_LOADING', isLoading });
export const cameraEntered = (camera) => ({ type: 'CAMERA_ENTERED', camera });
export const resetCameras = () => ({type: 'RESET_CAMERAS'});
export const cameraExited = (camera) => ({ type: 'CAMERA_EXITED', camera });
export const cameraMoved = (camera) => ({ type: 'CAMERA_MOVED', camera });
export const cameraFetchError = (error) => ({ type: 'CAMERA_FETCH_ERROR', error });
export const selecionaCamera = (camera) => ({type: 'SELECIONA_CAMERA', camera});
export const toggleListeningCameras = (isListening) => ({ type: 'TOGGLE_LISTENING_CAMERAS', isListening });
export const updateTimeline = (timeline) => ({ type: 'TIMELINE_UPDATED', timeline });
export const updateVideoUrl = (videoUrl) => ({ type: 'VIDEO_URL_UPDATED', videoUrl });
export const atualizaLocalizacaoCameras = (criteria) => (dispatch) => {
  return geoQuery &&
    typeof geoQuery.updateCriteria === 'function' &&
    geoQuery.updateCriteria(criteria);
};

export const registerCamerasListeners = () => (dispatch, getState) =>  {
  const todasCameras = () => {
    let user = firebase.auth().currentUser;
    const refUsersCameras = firebase.database().ref('users-cameras/' + user.uid);
    refUsersCameras.once('value', userCamerasSnap => {
      if (userCamerasSnap.val()) {
        loadCamerasByIds(Object.keys(userCamerasSnap.val()));
      }
    });
    const refGuardioes = firebase.database().ref('meus-guardioes/' + user.uid);
    refGuardioes.once('value', guardioesSnap => {
      if (guardioesSnap.val()) {
        let userIds = Object.keys(guardioesSnap.val());
        userIds.forEach(userId => {
          const ref = firebase.database().ref('users-cameras/' + user.uid);
          ref.once('value', userCamerasSnap => {
            loadCamerasByIds(Object.keys(userCamerasSnap.val()));
          });
        });
      }
    });
    const refGrupos = firebase.database().ref('meus-grupos/' + user.uid);
    refGrupos.once('value', gruposSnap => {
      if (gruposSnap.val()) {
        let groupIds = Object.keys(gruposSnap.val());
        groupIds.forEach(groupId => {
          const ref = firebase.database().ref('meus-compartilhamentos/camera/grupo/' + groupId);
          ref.once('value', camerasSnap => {
            if (camerasSnap.val()) {
              loadCamerasByIds(Object.keys(camerasSnap.val()));
            }
          });
        });
      }
    });
  }

  const loadCamerasByIds = (cameraIds) => {
    console.log("cameraIds: " + JSON.stringify(cameraIds));
    cameraIds.forEach(cameraId => {
      if (cameras.indexOf(cameraId) == -1) {
        cameras.push(cameraId);
        const ref = firebase.database().ref('cameras/' + cameraId);
        ref.once('value', cameraSnap => {
          if (cameraSnap.val()) { 
            const ref = firebase.database().ref('cameras-localizacao/' + cameraSnap.key);
            ref.once('value', cameraLocationSnap => {
              if (cameraLocationSnap.val()) {
                let value = cameraSnap.val();
                value.key = cameraSnap.key;
                value.coordenadas = cameraLocationSnap.val().l;
                dispatch(cameraEntered(value));
              }
            });
          }
        });
      }
    });  
  }


  firebase.auth().onAuthStateChanged(function(user) {
    dispatch(toggleListeningCameras(true));
    if (getState().route.match(/marcadores/)) {
      todasCameras();
      //minhasCameras(user);
      //camerasCompartilhadasViaGrupo(user);
      //camerasCompartilhadasViaGuardiao(user);
    }

    //camerasPublicas(user);
  });
};

export const removerPublicOnCop = (camera) => (dispatch) => {
  const ref = firebase.database().ref('cameras/'+camera.key);
  ref.set({ ...camera, publicOnCop: false });
  dispatch(cameraExited(camera));
}

export const unregisterCamerasListeners = () => (dispatch) => {
  dispatch(toggleListeningCameras(false));
  const ref = firebase.database().ref(URL);
  ref.off('value');
};

export const registerTimelineListener = (cameraId) => (dispatch, getState) => {
  const camerasRef = firebase.database().ref(`cameras/${cameraId}`);
  camerasRef.on('value', timeline => {
    let timelineObj = timeline.val();
    fetch(timelineObj.timeline)
      .then(response => response.json())
      .then(data => {
        timelineObj.timeline = data
        dispatch(updateTimeline(timelineObj));
      });
    });
};

export const unregisterTimelineListener = (cameraId) => (dispatch) => {
  firebase.database().ref(`cameras/${cameraId}`).off('value');
}



// WEBPACK FOOTER //
// ./src/actions/cameras.js